import type { AgencyContext } from "@/lib/auth";

export type RouteAccessDecision = "loading" | "redirect_login" | "redirect_recovery" | "redirect_dashboard" | "redirect_billing" | "allow";

type SubscriptionStatus = AgencyContext["subscription_status"];

export function isExpiredSubscriptionStatus(status: SubscriptionStatus | undefined) {
  return status === "expired" || status === "trial_expired";
}

export function shouldShowConsoleNavigation(_status: SubscriptionStatus | undefined) {
  return true;
}

export function accountTabForSubscription(_status: SubscriptionStatus | undefined, requestedTab: string | null) {
  return requestedTab || "profile";
}

export const EXPIRED_PLAN_ALLOWED_PATHS = [
  "/dashboard",
  "/findings",
  "/suspicious",
  "/payees",
  "/settings",
  "/account",
  "/support",
] as const;

export const EXPIRED_PLAN_FREE_DETECTORS = [
  "Double Dip",
  "New Payee",
  "Watched Payee",
  "Flagged Payee",
  "Global Flagged Payee",
] as const;

export function isExpiredPlanRestrictedPath(pathname: string) {
  return !EXPIRED_PLAN_ALLOWED_PATHS.some((allowed) => pathname === allowed || pathname.startsWith(`${allowed}/`));
}

export function isAdminUser(userRole: AgencyContext["user_role"] | undefined) {
  return userRole === "admin";
}

export function resolveRouteAccess({
  loading,
  hasUser,
  deletionPending,
  requireDeletionPending = false,
  allowDeletionPending = false,
  requireActiveSubscription = false,
  subscriptionStatus,
  userRole,
}: {
  loading: boolean;
  hasUser: boolean;
  deletionPending: boolean;
  requireDeletionPending?: boolean;
  allowDeletionPending?: boolean;
  requireActiveSubscription?: boolean;
  subscriptionStatus?: SubscriptionStatus;
  userRole?: AgencyContext["user_role"];
}): RouteAccessDecision {
  if (loading) {
    return "loading";
  }
  if (!hasUser) {
    return "redirect_login";
  }
  if (requireDeletionPending && !deletionPending) {
    return "redirect_dashboard";
  }
  if (deletionPending && !allowDeletionPending) {
    return "redirect_recovery";
  }
  if (requireActiveSubscription && isExpiredSubscriptionStatus(subscriptionStatus) && !isAdminUser(userRole)) {
    return "redirect_billing";
  }
  return "allow";
}
